import type { SVGProps } from "react";

export const Close = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 20 20"
      width={16}
      height={16}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
    >
      <path
        d="M11.0625 10L15 13.8875L13.9375 14.95L10 11.0625L6.1125 15L5 13.8875L8.9375 10L5 6.1125L6.1125 5L10 8.9375L13.8875 5L14.95 6.0625L11.0625 10Z"
        fill="currentColor"
      />
    </svg>
  );
};
